<template> 
  <modal name="shipment-delivery-date" height="auto" @opened="onOpened" @before-open="beforeOpen">
    <div class="col-sm-12" style="display:inline-block;">
      <div class="form-group">
        <h4 class="card-title">Delivery Date and Time</h4>
      </div>


      <input id="deliverydate" type="text" v-model="deliveryDate" class="form-control delivery-datetimepicker" name="deliverydate" data-vv-as="delivery date" v-validate="'required|validDate'">
      <div style="display:inline-block; height: 300px;"></div>

      <div class="row">
        <div class="col-sm-6">
          <p v-show="errors.has('deliverydate')" class="help is-danger">{{ errors.first('deliverydate') }}</p>
          <p v-show="serverError" class="help is-danger">{{ serverError }}</p>
        </div>
        <div class="col-sm-6">
          <div class="form-group form-actions">
            <button class="btn btn-success btn-wd float-right" style="margin-bottom: 16px" :disabled="submiting" @click="setDate"><i class="fa fa-save"></i> Save</button>
          </div>
        </div>

      </div>
    </div>


  </modal>
</template>

<script>
import "../../static/js/bootstrap-datetimepicker.js"
import apiService from '../services/api.service'

export default {
  name: 'ShipmentDeliveryDateModal',
  data: function () {
    return {
      rfqId: "",
      deliveryDate: "",
      serverError: "",
      submiting: false
    }
  },
  computed: {
    deliveryDateTime() {
      return newSafeDate(this.deliveryDate);
    }
  },
  methods: {
    onOpened() {
      initDatePickers('.delivery-datetimepicker');
    },
    beforeOpen(event) {
      this.rfqId = event.params.rfqId;
      this.deliveryDate = "";
      this.serverError = "";
    },
    async setDate() {
      this.submiting = true;
      this.serverError = ""

      await this.$validator.validateAll();
      if (this.errors.any()){
        this.submiting = false;
        return;
      };

      try {
        const resp = await apiService.put(`/shipment/setDeliveryDate/${this.rfqId}`, {
          deliveryTime: this.deliveryDateTime.getTime()
        });

        this.$parent.$emit('deliveryDateSet', { date: this.deliveryDateTime });
        this.$modal.hide("shipment-delivery-date");
      } catch (error) {
        this.serverError = "Failed to set delivery date."
      }

      this.submiting = false;
    }
  }
}
</script>


// WEBPACK FOOTER //
// ShipmentDeliveryDateModal.vue?a1f63934